import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Landing } from '@/landing/Landing';

// Everything dashboard-related is lazy. Landing visitors only download
// React + react-router + the Landing chunk.
const AppRoot            = lazy(() => import('@/routes/AppRoot'));
const DashboardRoute     = lazy(() => import('@/routes/DashboardRoute'));
const ScenariosRoute     = lazy(() => import('@/routes/ScenariosRoute'));
const CallLogsRoute      = lazy(() => import('@/routes/CallLogsRoute'));
const IntegrationsRoute  = lazy(() => import('@/routes/IntegrationsRoute'));
const SettingsRoute      = lazy(() => import('@/routes/SettingsRoute'));
const StoreSettingsRoute = lazy(() => import('@/routes/StoreSettingsRoute'));
const PlaceholderRoute   = lazy(() => import('@/routes/PlaceholderRoute'));

export default function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Landing />} />

        {/* Dashboard — AppDataProvider lives inside AppRoot, also lazy */}
        <Route path="/app" element={<AppRoot />}>
          <Route index                element={<DashboardRoute />} />
          <Route path="scenarios"     element={<ScenariosRoute />} />
          <Route path="call-logs"     element={<CallLogsRoute />} />
          <Route path="integrations"  element={<IntegrationsRoute />} />
          <Route path="settings"      element={<SettingsRoute />} />
          <Route path="store"         element={<StoreSettingsRoute />} />
          <Route path="templates"     element={<PlaceholderRoute route="templates" />} />
          <Route path="team"          element={<PlaceholderRoute route="team" />} />
          <Route path="billing"       element={<PlaceholderRoute route="billing" />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
